var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import MasterCardPill from "./mastercardPill";
import { getMasterCardBackground } from "./mixins/background";
import { MasterCardContainer } from "./styled";
var minWidths = {
    default: "29px",
    large: "37px",
};
var MasterCard = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a["data-testid"], testId = _b === void 0 ? "mastercard" : _b, height = _a.height, normal = _a.normal, onClick = _a.onClick, _c = _a.pillLeft, pillLeft = _c === void 0 ? {} : _c, _d = _a.pillRight, pillRight = _d === void 0 ? {} : _d, round = _a.round, size = _a.size, rest = __rest(_a, ["children", "data-testid", "height", "normal", "onClick", "pillLeft", "pillRight", "round", "size"]);
    var commonProps = { height: height, round: round, size: size };
    var pillProps = __assign(__assign({ normal: normal }, commonProps), rest);
    var pillRightBackground = getMasterCardBackground(pillRight.background, pillRight.flavour || "disabledWarning");
    var pillLeftProps = __assign(__assign({ background: getMasterCardBackground(pillLeft.background, pillLeft.flavour || "disabledError"), padding: [1, 3], position: "relative", width: { min: minWidths[rest.size] || minWidths.default } }, pillProps), pillLeft);
    var pillRightProps = __assign(__assign({ background: pillRightBackground, margin: [0, 0, 0, -1], padding: [1, 2] }, pillProps), pillRight);
    return (React.createElement(MasterCardContainer, __assign({ background: pillRightBackground, "data-testid": testId, onClick: onClick, ref: ref }, commonProps), children || (React.createElement(React.Fragment, null,
        React.createElement(MasterCardPill, __assign({ "data-testid": "".concat(testId, "-left-pill") }, pillLeftProps)),
        React.createElement(MasterCardPill, __assign({ "data-testid": "".concat(testId, "-right-pill") }, pillRightProps))))));
});
export default MasterCard;
